// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestionCard-cls1___6094e1620430f8f4e1b{/*!*/}.SuggestionCard-cls2__eb6b5bae34d3457b72de{display:flex;justify-content:space-between}.SuggestionCard-cls2__eb6b5bae34d3457b72de.SuggestionCard-small__efbf4f3dfe90a8bad85e{margin-bottom:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestionCard-cls1___6094e1620430f8f4e1b",
	"cls2": "SuggestionCard-cls2__eb6b5bae34d3457b72de SuggestionCard-cls1___6094e1620430f8f4e1b",
	"small": "SuggestionCard-small__efbf4f3dfe90a8bad85e"
};
export default ___CSS_LOADER_EXPORT___;
